export default {"src":"/_next/static/media/icone-helio.8db2fdf7.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};